export enum ObstetricsConstants {
  NOT_IMPLEMENTED = 'obstetrics/NOT_IMPLEMENTED',
  SET_IS_PATIENT_PREGNANT = 'obstetrics/SET_IS_PATIENT_PREGNANT',
  SET_IS_PATIENT_PREGNANT_PNNV = 'obstetrics/SET_IS_PATIENT_PREGNANT_PNNV',
  SET_GRAVIDA = 'obstetrics/SET_GRAVIDA',
  SET_PARA = 'obstetrics/SET_PARA',
  SET_GESTATIONAL_AGE_WEEKS = 'obstetrics/SET_GESTATIONAL_AGE_WEEKS',
  SET_GESTATIONAL_AGE_DAYS = 'obstetrics/SET_GESTATIONAL_AGE_DAYS',
  SET_EXPECTED_DATE_OF_CONFINEMENT = 'obstetrics/SET_EXPECTED_DATE_OF_CONFINEMENT',
  SET_LAST_MENSTRUAL_PERIOD = 'obstetrics/SET_LAST_MENSTRUAL_PERIOD',
  SET_INITIAL_FETAL_HEART_RATE = 'obstetrics/SET_INITIAL_FETAL_HEART_RATE',
  SET_CONTRACTIONS_FREQUENCY = 'obstetrics/SET_CONTRACTIONS_FREQUENCY',
  SET_CONTRACTIONS_DURATION = 'obstetrics/SET_CONTRACTIONS_DURATION',
  SET_MEMBRANES_AMNIOTIC_FLUID = 'obstetrics/SET_MEMBRANES_AMNIOTIC_FLUID',
  SET_RUPTURE_TIME = 'obstetrics/SET_RUPTURE_TIME',
  SET_DILATION = 'obstetrics/SET_DILATION',
  SET_EFFACEMENT = 'obstetrics/SET_EFFACEMENT',
  SET_MATERNAL_MEDICATIONS_ADMINISTERED = 'obstetrics/SET_MATERNAL_MEDICATIONS_ADMINISTERED',
  SET_PRESENTING_PART = 'obstetrics/SET_PRESENTING_PART',
  SET_BLOODY_SHOW = 'obstetrics/SET_BLOODY_SHOW',
  SET_PRENATAL_CARE = 'obstetrics/SET_PRENATAL_CARE',
  SET_COMMENTS = 'obstetrics/SET_COMMENTS',

  SAVE_OBSTETRICS = 'obstetrics/SAVE_OBSTETRICS',
  SET_OBSTETRICS = 'obstetrics/SET_OBSTETRICS',
  RESET_OBSTETRICS = 'obstetrics/RESET_OBSTETRICS',
}
